import type { IQuizRepository } from '@/core/domain/quiz/IQuizRepository.ts'
import type { Quiz } from '@/core/domain/quiz/Quiz.ts'

export class FetchQuizUseCase {
  private readonly quizRepository: IQuizRepository

  constructor(quizRepository: IQuizRepository) {
    this.quizRepository = quizRepository
  }

  async execute(quizId: number): Promise<Quiz> {
    return await this.quizRepository.fetchQuiz(quizId)
  }
}
